module.exports = __webpack_public_path__ + "img/photoshop.93809a87.svg";